import * as Yup from 'yup';

export const passwordValidator = () => {
    return Yup.string().max(99).required('Requis').matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.\[\]{}\(\)?\-"!@#%&\/,><\':;|_~`])\S{8,99}$/,
        "Doit contenir 8 caractères, une majuscule, une minuscule, un nombre et un caractère spécial."
    )
}